<template>
  <div class="feedbackPage modelPage">
    <!-- <navbar :nav="nav"></navbar> -->
  <van-nav-bar
    :title="nav.title"
    :left-arrow="nav.back"
    @click-left="onClickLeft"
  >
  </van-nav-bar>
    <div class="feedbackContent">
      <van-field
        :class="textareaFocus ? 'textareaFocus' : ''"
        v-model="message"
        autosize
        rows="2"
        type="textarea"
        placeholder="こちらにご意見をお寄せください"
        maxlength="200"
        show-word-limit
        @focus="textareaFocus = true"
        @blur="textareaFocus = false"
      />
      <van-uploader
        :class="fileList.length == 0 ? 'onlyOne' : ''"
        v-model="fileList"
        multiple
        :max-count="9"
        :deletable="true"
        :after-read="afterRead"
        :max-size="200 * 1024 * 1024"
        :preview-options="{ closeable: true }"
        @oversize="onOversize"
        @delete="deleteImg"
      />
    </div>
    <van-button
      round
      block
      type="info"
      native-type="submit"
      class="buttonBlue userButton"
      @click="saveFeedback()"
      >送信</van-button
    >
    <van-popup v-model="feedPopup">
        <div class="content">
          <div>変更を保存せずに画面を閉じますか？</div>
        </div>
        <div class="buttonItem">
          <div class="button cancel" @click="$router.back(1)">
            閉じる
          </div>
          <div class="button sure" @click="feedPopup = false">編集を続ける</div>
        </div>
      </van-popup>

  </div>
</template>

<script>
import Vue from "vue";
import { Uploader } from "vant";
import { Toast } from "vant";
import { NavBar } from "vant";

Vue.use(NavBar);
Vue.use(Uploader);
Vue.use(Toast);
import navbar from "../../components/navbar/index.vue";
import { feedkackCreate, upload } from "@/http/user";
import ImageCompressor from "image-compressor.js";
import axios from "axios";
export default {
  components: {
    navbar
  },
  data() {
    return {
      nav: {
        back: true,
        title: "ご意見・ご要望",
        chat: false
      },
      textareaFocus: false,
      message: "",
      fileList: [],
      pictureList: [],
      feedPopup: false,
    };
  },
  mounted() {},
  methods: {
    onClickLeft() {
      if (this.message != "" || this.pictureList.length>0) {
        this.feedPopup = true
        return
      }
      this.$router.back(1);
    },

    deleteImg(file, detail) {
      let index = detail.index;
      this.pictureList.splice(index, 1);
    },
    onOversize(file) {
      Toast({
        type: "fail",
        icon: "cross",
        message: "画像が大きすぎる"
      });
    },
    afterRead(file) {
      let size = file.file.size;
      file.status = "uploading";
      let USER_TOKEN = localStorage.getItem("token")
        ? localStorage.getItem("token")
        : "";
      let quality = 1;
      if (size < 2000 * 1000) {
        //小于2M
        quality = 0.8;
      } else if (size < 5000 * 1000) {
        //小于5M
        quality = 0.5;
      } else if (size < 10000 * 1000) {
        //小于10M
        quality = 0.3;
      } else {
        //大于10M
        quality = 0.1;
      }
      new ImageCompressor(
        file.file, // 需要压缩的图片文件
        {
          quality: quality, // 压缩的比率 0.6刚好
          success: res => {
            //  res 转换之后的文件流
            // 压缩成功之后默认是blob文件，那么这里采用原生的文件转换，其实就是新创建一个文件
            let files = new window.File([res], res.name, { type: res.type });
            let form = new FormData();
            form.append("file", files);
            const instance = axios.create({
              withCredentials: true
            });
            instance({
              method: "post",
              url: "https://apibk.smartsketcher-ai.com/app-api/system/s3/upload",
              data: form,
              headers: {
                Authorization: "Bearer " + USER_TOKEN,
                "tenant-Id": "1",
                "Content-Type": "multipart/form-data"
              }
            })
              .then(res => {
                let { data, code } = res.data;
                if (code == 200) {
                  file.status = "done";
                  this.pictureList.push(data);
                } else {
                  file.status = "failed";
                }
              })
              .catch(err => {
                file.status = "failed";
              });
          },
          error(e) {
            console.log(e);
          }
        }
      );
      return;
    },
    saveFeedback() {
      if (!this.message || this.message == "") {
        Toast({
          type: "fail",
          icon: "cross",
          message: "画像に説明を追加してください。"
        });
        return;
      }
      // if (this.fileList.length == 0) {
      //   Toast({
      //     type: "fail",
      //     icon: "cross",
      //     message: "フィードバック画像を選択してください"
      //   });
      //   return;
      // }
      let query = {
        feedbackContent: this.message,
        pictureList: this.pictureList
      };
      feedkackCreate(query).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          Toast({
            type: "success",
            message: "送信しました"
          });

          this.message = "";
          this.fileList = [];
          this.pictureList = [];
        }
      });
    }
  }
};
</script>

<style src="@/assets/css/mycenter.css" scoped></style>
<style>
.feedbackContent {
  padding: 0 16px 16px 16px;
  font-family: MediumFont;
  font-size: 16px;
  height: calc(100% - 130px);
  overflow-y: scroll;
}
.feedbackContent .van-cell {
  width: 100%;
  height: 160px;
  border-radius: 12px;
  line-height: 22px;
  font-size: 16px;
  padding: 0 16px;
  border: 1.5px solid #fff;
  box-sizing: border-box;
  margin-bottom: 16px;
}
.feedbackContent .van-cell.textareaFocus {
  border: 1.5px solid #2b99ff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0);
}
.feedbackContent .van-field__body {
  /* height: 70px; */
  /* height: 70px; */
  /* overflow: auto;
  padding: 16px 0; */
  height: 110px;
  overflow: auto;
  /* padding: 0.426667rem 0; */
  box-sizing: border-box;
  margin-top: 15px;
  /* padding-top: 28px; */
  align-items: flex-start;
}
.feedbackContent .van-field__control {
  font-family: RegularFont;
  font-size: 16px;
  font-weight: normal;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.9);
  height: auto !important;
  min-height: 110px !important;
  overflow-y: scroll;
}
.feedbackContent .van-field__word-limit {
  font-family: RegularFont;
  font-size: 12px;
  font-weight: normal;
  line-height: 21px;
  color: rgb(0, 0, 0, 0.5);
}
.feedbackContent .textareaBox.textareaMax .van-cell.textareaFocus {
  border: 1.5px solid #ff2f6a;
}
.feedbackContent .textareaBox.textareaMax .textareaLength {
  color: #ff2f6a;
}
.feedbackContent .van-uploader {
  width: 100%;
}
.feedbackContent .van-uploader__preview-image {
  width: 100%;
  height: 120px;
  border-radius: 0.213333rem;
}
.feedbackContent .van-uploader__preview,
.feedbackContent .van-uploader__upload {
  /* width: 33%; */
  width: calc(33.3% - 11px);
  margin: 0 16px 16px 0;
  /* margin: 0 0 0 0; */
  border-radius: 8px;
  overflow: hidden;
}
.feedbackContent .van-uploader__preview:nth-child(3n) {
  margin-right: 0;
}
.feedbackContent .van-uploader__upload {
  height: 120px;
  margin: 0 0 16px 0;
  background: #ffffff;
}
.feedbackContent .onlyOne .van-uploader__upload {
  width: 100%;
}
.van-uploader__preview-delete {
  border-radius: 0 0 0 6px;
  width: 16px;
  height: 16px;
}
.feedbackContent .van-uploader__preview-delete-icon {
  top: 0px;
  right: 0px;
}
.feedbackContent .van-uploader__upload-icon {
  font-size: 40px;
  border: 1px dashed #d7e0ea;
  padding: 10px;
  border-radius: 8px;
}

@media screen and (min-width: 1439px) {
  .feedbackContent {
    padding: 0 16px 16px 16px; /* no*/
    font-size: 16px; /* no*/
    height: calc(100% - 130px); /* no*/
  }
  .feedbackContent .van-cell {
    width: 100%; /* no*/
    height: 160px; /* no*/
    border-radius: 12px; /* no*/
    line-height: 22px; /* no*/
    font-size: 16px; /* no*/
    padding: 0 16px; /* no*/
    border: 1.5px solid #fff; /* no*/
    margin-bottom: 16px; /* no*/
  }
  .feedbackContent .van-cell.textareaFocus {
    border: 1.5px solid #2b99ff; /* no*/
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0); /* no*/
  }
  .feedbackContent .van-field__body {
    height: 110px; /* no*/
    margin-top: 15px; /* no*/
  }
  .feedbackContent .van-field__control {
    font-size: 16px; /* no*/
    line-height: 22px; /* no*/
  }
  .feedbackContent .van-field__word-limit {
    font-size: 12px; /* no*/
    line-height: 21px; /* no*/
  }
  .feedbackContent .textareaBox.textareaMax .van-cell.textareaFocus {
    border: 1.5px solid #ff2f6a; /* no*/
  }
  .feedbackContent .van-uploader__preview-image {
    height: 140px; /* no*/
  }
  .feedbackContent .van-uploader__preview,
  .feedbackContent .van-uploader__upload {
    width: calc(33.3% - 11px); /* no*/
    margin: 0 16px 16px 0; /* no*/
    border-radius: 8px; /* no*/
  }
  .feedbackContent .van-uploader__upload {
    height: 140px; /* no*/
    margin: 0 0 16px 0; /* no*/
  }
  .van-uploader__preview-delete {
    border-radius: 0 0 0 6px; /* no*/
    width: 16px; /* no*/
    height: 16px; /* no*/
  }
  .feedbackContent .feedbackContent .van-uploader__upload-icon {
    font-size: 40px; /* no*/
    border: 1px dashed #d7e0ea; /* no*/
    padding: 10px; /* no*/
    border-radius: 8px; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/model/feedback.vue